import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Badge from '../Badge/Badge';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import HeaderContext from './HeaderContext';

const HeaderNavMobileItem = ({
  activates,
  badge,
  children,
  className,
  href,
  icon,
  onClick,
  targetBlank,
}) => {
  const { activeFlyout, toggleFlyout, closeMegaMenu } =
    useContext(HeaderContext);

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    } else if (activates) {
      toggleFlyout(activates);
      if (activeFlyout) {
        closeMegaMenu();
      }
    }
  };

  return (
    <li
      className={`o-list-inline__item  c-header-main-nav-mob__item  ${className}`}
    >
      <Button
        color="subtle"
        className="c-header-main-nav-mob__link"
        href={href}
        onClick={handleClick}
        {...(targetBlank ? { target: '_blank' } : {})}
      >
        <Icon icon={activeFlyout === activates ? 'close' : icon} />
        {badge && (
          <Badge color="primary" bold className="c-header-top__badge">
            {badge}
          </Badge>
        )}
        <span className="c-header-main-nav-mob__text  u-show@tablet">
          {children}
        </span>
      </Button>
    </li>
  );
};

export default HeaderNavMobileItem;

HeaderNavMobileItem.propTypes = {
  activates: PropTypes.string,
  badge: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  targetBlank: PropTypes.bool,
};

HeaderNavMobileItem.defaultProps = {
  activates: '',
  badge: null,
  children: null,
  className: '',
  href: '',
  icon: '',
  onClick: null,
  targetBlank: false,
};
